<script lang="ts">
  let { name, phone }: { name: string; phone: string } = $props();

  const initial = $derived(name.length > 0 ? name[0]!.toUpperCase() : (phone.slice(1, 2) || '?'));
</script>

<div class="avatar" aria-hidden="true">{initial}</div>

<style>
  .avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: var(--brand);
    color: var(--brand-ink);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 18px;
    flex-shrink: 0;
  }
</style>
